/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box, Grid, Paper, Typography, Button } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import OrderDetailsCard from './orderDetailsCard.component';
// import ProcessDetailsCard from './processDetailsCard.component';
import Spinner from 'modules/common/spinner.component';
import SpreadSelectorCard from './spreadSelectorCard.component';
// import BrokerProcessDetailsCard from './brokerProcessDetailsCard.component';
import BrokerPreferencesCard from './brokerPreferencesCard.component';
import classNames from 'classnames';
import { useState } from 'react';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const AppraisalBmaDetails = props => {
  const {
    appraisalId,
    appraisalsSelected,
    vendors,
    details,
    id,
    isLoadingEstimates,
    isReadOnly,
    orderList,
    isOrderingList,
    setAppraisalId,
    setShowAddAppraiser,
    setShowAddBroker,
    enumerations,
    validTemplates,
    sentEmailTemplates,
    history
  } = props;

  // const normalizedBrokerAgentTypeId = appraisalsSelected
  //   ? '64d84439-cada-49c8-b69d-be5efc248ae7'
  //   : 'cd63fc17-0a35-45cb-84bb-78cac93ea8c0';

  const normalizedVendors = useMemo(
    () =>
      (vendors || []).map(vendor => {
        if (vendor?.vendorId) {
          return vendor;
        }

        return {
          ...vendor,
          agentId: vendor?.vendorId ?? null,
          companyName: vendor?.companyName || ''
        };
      }),
    [vendors]
  );

  const [appraisalInfo, setAppraisalInfo] = useState(
    details?.homesale?.appraisalsBmas ? details?.homesale?.appraisalsBmas.find(a => a.homesaleAppraisalId === appraisalId) : null
  );

  useEffect(() => {
    if (details && details?.homesale?.appraisalsBmas) {
      const curAppraisalInfo = details?.homesale?.appraisalsBmas.filter(
        a => a.appraisalTypeId === (appraisalsSelected ? '1bc0f499-6ed9-4400-b777-fc660f69b68c' : '1ab09957-1ae8-4463-aba7-8ac96cc0b427')
      )[0];
      setAppraisalInfo(curAppraisalInfo);
      setAppraisalId(curAppraisalInfo?.homesaleAppraisalId);
    }
  }, [appraisalsSelected]);

  useEffect(() => {
    if (details && details?.homesale?.appraisalsBmas) {
      if (appraisalId) {
        const curAppraisalInfo = details?.homesale?.appraisalsBmas.find(a => a.homesaleAppraisalId === appraisalId);
        setAppraisalInfo(curAppraisalInfo);
      } else {
        const curAppraisalInfo = details?.homesale?.appraisalsBmas.filter(
          a => a.appraisalTypeId === (appraisalsSelected ? '1bc0f499-6ed9-4400-b777-fc660f69b68c' : '1ab09957-1ae8-4463-aba7-8ac96cc0b427')
        )[0];
        setAppraisalInfo(curAppraisalInfo);
        setAppraisalId(curAppraisalInfo?.homesaleAppraisalId);
      }
    }
  }, [details?.homesale?.appraisalsBmas]);

  useEffect(() => {
    if (appraisalId && details && details?.homesale?.appraisalsBmas) {
      setAppraisalInfo(details?.homesale?.appraisalsBmas.find(a => a.homesaleAppraisalId === appraisalId));
    }
  }, [appraisalId]);

  return (
    <Box>
      {!isReadOnly && appraisalInfo == null && !isLoadingEstimates && (
        <Box sx={{ padding: '20px', fontSize: '20px' }}>
          <b>No {appraisalsSelected ? 'Appraisal' : 'BMA'} selected. Create a new one below to get started.</b>
        </Box>
      )}
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} xl={6} rowSpacing={2}>
          <SpreadSelectorCard
            appraisalsSelected={appraisalsSelected}
            fileId={id}
            vendors={normalizedVendors}
            appraisalsBmas={details?.homesale?.appraisalsBmas.filter(
              a =>
                a.appraisalTypeId === (appraisalsSelected ? '1bc0f499-6ed9-4400-b777-fc660f69b68c' : '1ab09957-1ae8-4463-aba7-8ac96cc0b427')
            )}
            homesaleInfo={details?.homesale?.spreadSelection}
            isReadOnly={isReadOnly}
          />
          <Box sx={{ paddingTop: '16px' }}>
            <BrokerPreferencesCard
              details={details}
              appraisalsSelected={appraisalsSelected}
              appraisalPreferences={details?.homesale?.appraisalPreferences}
              orderList={orderList}
              isOrderingList={isOrderingList}
              isReadOnly={isReadOnly}
              fileId={id}
              homesaleId={details?.homesale?.homesaleInfo?.homesaleId}
            />
          </Box>
        </Grid>
        <Grid item xs={12} xl={6}>
          <Paper
            square
            className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}
            sx={{
              position: 'sticky',
              padding: '20px',
              marginBottom: '15px',
              minWidth: '100%'
            }}
          >
            {appraisalsSelected && (
              <>
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      paddingBottom: '5px'
                    }}
                  >
                    Select Appraiser
                  </Typography>
                </Box>
              </>
            )}
            {!appraisalsSelected && (
              <>
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      paddingBottom: '5px'
                    }}
                  >
                    Select Broker
                  </Typography>
                </Box>
              </>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box>
                <Paper squarestyle={{ minWidth: '300px', maxWidth: '600px', maxHeight: '125px', minHeight: '100px', overflowY: 'scroll' }}>
                  {details &&
                    details?.homesale?.appraisalsBmas &&
                    details?.homesale?.appraisalsBmas
                      .filter(
                        a =>
                          a.appraisalTypeId ===
                          (appraisalsSelected ? '1bc0f499-6ed9-4400-b777-fc660f69b68c' : '1ab09957-1ae8-4463-aba7-8ac96cc0b427')
                      )
                      .map(opt => {
                        const selectedBrokerAgent = normalizedVendors.find(a => a.vendorId === opt.vendorId);
                        const selectedBrokerAgentName = [selectedBrokerAgent?.companyName]
                          .filter(Boolean)
                          .join(' ')
                          .trim();
                        const selectedBrokerAgentRanking =
                          details?.homesale?.appraisalsBmas.find(a => a.vendorId === opt.vendorId)?.agentRanking || null;
                        return (
                          <Box
                            sx={{
                              padding: '10px',
                              backgroundColor: appraisalId === opt.homesaleAppraisalId ? '#c5e3d3' : undefined,
                              cursor: 'pointer',
                              '&:hover': { backgroundColor: appraisalId === opt.homesaleAppraisalId ? '#5D9878' : 'lightgrey' }
                            }}
                            onClick={() => {
                              setAppraisalId(opt.homesaleAppraisalId);
                              setAppraisalInfo(opt);
                            }}
                          >
                            {appraisalsSelected ? selectedBrokerAgentRanking : ''}{' '}
                            {selectedBrokerAgentName || selectedBrokerAgent?.companyName || ''},{' '}
                            {new Date(opt.ordered).toLocaleDateString()}
                          </Box>
                        );
                      })}
                </Paper>
              </Box>
              {!isReadOnly && (
                <>
                  {appraisalsSelected && (
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onClick={() => setShowAddAppraiser(true)}
                    >
                      New Appraiser
                    </Button>
                  )}
                  {!appraisalsSelected && (
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onClick={() => setShowAddBroker(true)}
                    >
                      New Broker
                    </Button>
                  )}
                </>
              )}
            </Box>
          </Paper>
          {appraisalInfo != null && !isLoadingEstimates && (
            <>
              <Box>
                <OrderDetailsCard
                  appraisalsSelected={appraisalsSelected}
                  fileId={id}
                  appraisalInfo={appraisalInfo}
                  vendors={normalizedVendors}
                  isReadOnly={isReadOnly}
                  appTypes={enumerations.allEnums.appraisalTypes}
                  appraisalId={appraisalId}
                  bmaTemplates={validTemplates}
                  appraisalTemplates={validTemplates}
                  sentTemplates={sentEmailTemplates}
                  communication={details.authorizationDetails}
                  history={history}
                />
              </Box>
              {/* {appraisalsSelected && (
                <>
                  <Box sx={{ paddingTop: '16px' }}>
                    <ProcessDetailsCard
                      appraisalsSelected={appraisalsSelected}
                      fileId={id}
                      appraisalInfo={appraisalInfo}
                      brokerAgents={brokerAgents}
                      isReadOnly={isReadOnly}
                      statusEnum={enumerations.allEnums.appraisalStatuses}
                    />
                  </Box>
                </>
              )} */}
              {/* {!appraisalsSelected && (
                <>
                  <Box sx={{ paddingTop: '16px' }}>
                    <BrokerProcessDetailsCard
                      appraisalsSelected={appraisalsSelected}
                      fileId={id}
                      appraisalInfo={appraisalInfo}
                      brokerAgents={brokerAgents}
                      isReadOnly={isReadOnly}
                      statusEnum={enumerations.allEnums.appraisalStatuses}
                    />
                  </Box>
                </>
              )} */}
            </>
          )}
        </Grid>
      </Grid>
      {isLoadingEstimates && <Spinner />}
    </Box>
  );
};

const mapStateToProps = state => {
  return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, {}))(AppraisalBmaDetails);
